import { render, staticRenderFns } from "./myPrivateSeal.vue?vue&type=template&id=06f0754e&scoped=true"
import script from "./myPrivateSeal.vue?vue&type=script&lang=js"
export * from "./myPrivateSeal.vue?vue&type=script&lang=js"
import style0 from "./myPrivateSeal.vue?vue&type=style&index=0&id=06f0754e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0754e",
  null
  
)

export default component.exports